//カード編集画面
import React, { useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Paper, Tabs, Tab } from '@material-ui/core';

import { CardDb } from '../redux/cardDbSlice';
import { CardAttributeDbHashType } from '../redux/cardAttributeDbSlice';
import EditCardContents from './EditCardContents';
import DesignCard from './DesignCard';
import TabPanel, { TabsAppBar, tabsIndicatorTheme, a11yProps } from '../components/TabPanel';
import { EditCardShapeDbHashType } from '../components/EditDialog';

type EditCommonCardProps = {
  cardId: string;
  card: CardDb;
  setCard: (card: CardDb) => void;
  attributes: CardAttributeDbHashType;
  setAttributes: (items: CardAttributeDbHashType) => void;
  shapes: EditCardShapeDbHashType;
  setShapes: (shapes: EditCardShapeDbHashType) => void;
  splitUpdated: boolean;
}
const EditCommonCard: React.FC<EditCommonCardProps> = ({ cardId, card, setCard, attributes, setAttributes, shapes, setShapes, splitUpdated }) => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  }

  return (
    <Paper>
      <ThemeProvider theme={tabsIndicatorTheme}>
        <TabsAppBar position="static" elevation={0}>
          <Tabs value={value} onChange={handleChange} variant="fullWidth">
            <Tab label="内容" {...a11yProps(0)} />
            <Tab label="デザイン" {...a11yProps(1)} />
          </Tabs>
        </TabsAppBar>
        <TabPanel value={value} index={0}>
          <EditCardContents cardId={cardId} card={card} setCard={setCard}
            attributes={attributes} setAttributes={setAttributes}
            shapes={shapes}
            splitUpdated={splitUpdated}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DesignCard cardId={cardId} card={card} setCard={setCard}
            attributes={attributes} setAttributes={setAttributes}
            shapes={shapes} setShapes={setShapes}
            splitUpdated={splitUpdated}
          />
        </TabPanel>
      </ThemeProvider>
    </Paper> 
  );
}

export default EditCommonCard;
